import React from 'react'
import Navbar from '../../../components/Navbar'
import BackToTop from '../../../components/BackToTop'
import { Container, NavbarGroup, Content } from '../style'

export default function Security() {
  return (
    <Container>
      <Container id="back-to-top-anchor" />

      <Navbar />

      <NavbarGroup aria-label="Conteúdo da página">
        <p>Índice</p>

        <ul>
          <li>
            <a href="#1">
              <span><strong>1.</strong> Objetivos</span>
            </a>
          </li>

          <li>
            <a href="#2">
              <span><strong>2.</strong> Abrangência</span>
            </a>
          </li>

          <li>
            <a href="#3">
              <span><strong>3.</strong> Diretrizes</span>
            </a>
          </li>

          <li>
            <a href="#4">
              <span><strong>4.</strong> Penalidades</span>
            </a>
          </li>

          <li>
            <a href="#5">
              <span><strong>5.</strong> Vigência</span>
            </a>
          </li>

          <li>
            <a href="#6">
              <span><strong>6.</strong> Documentos Relacionados</span>
            </a>
          </li>

          <li>
            <a href="#7">
              <span><strong>7.</strong> Versão e Revisão</span>
            </a>
          </li>
        </ul>
      </NavbarGroup>

      <Content>
        <h1>Política de Segurança da Informação</h1>

        <p id="1"><strong>Objetivos</strong></p>
        <p>A seguinte Política de Segurança da Informação tem como objetivo o que segue:</p>
        <ul>
            <li>Expressar como a StartSe pensa e adota medidas e controles de segurança para proteger seus ativos, alinhados com os objetivos do negócio;</li>
            <li>Estabelecer diretrizes e normas de Segurança da Informação que permitam aos colaboradores da StartSe adotar padrões de comportamento seguro, adequadas às suas atividades, metas e necessidades;</li>
            <li>Orientar colaboradores quanto a adoção de processos e procedimentos para atendimento dos requisitos de Segurança da Informação;</li>
            <li>Capacitar os colaboradores no que se refere à prevenção, detecção e resposta a incidentes de Segurança da Informação;</li>
            <li>Prevenir possíveis causas de incidentes de Segurança da Informação;</li>
            <li>Resguardar ativos de informação e ativos tecnológicos da StartSe, garantindo requisitos de confidencialidade, integridade e disponibilidade;</li>
            <li>Minimizar os riscos de perdas financeiras, da confiança do cliente ou de qualquer outro impacto negativo no negócio como resultado de falhas de segurança.</li>
        </ul>
        <br/>

        <p id="2"><strong>Abrangência</strong></p>
        <p>Aplica-se a todos os acionistas, colaboradores, estagiários, parceiros, fornecedores, prestadores de serviço, bem como qualquer local onde se encontre informação e ativos de tecnologia que pertençam a StartSe.</p>
        <br/>

        <p id="3"><strong>Diretrizes</strong></p>
        <p>Nosso compromisso com o tratamento adequado das informações da Instituição, clientes e público em geral está fundamentado nos seguintes princípios:</p>
        <ul>
          <li>Confidencialidade - Garantir que o acesso à informação seja obtido somente por pessoas autorizadas e quando ele for de fato necessário; </li>
          <li>Disponibilidade - Garantir que as pessoas autorizadas tenham acesso à informação sempre que necessário; </li>
          <li>Integridade - Garantir a exatidão e a completude da informação e dos métodos de seu processamento, bem como da transparência no trato com os públicos envolvidos.</li>
        </ul>
        

        <p>A Segurança da Informação na StartSe estabelece as diretrizes a seguir:</p>
        <ol type="a">
          <li>As informações da Instituição, dos clientes e do público em geral são tratadas de forma ética, sigilosa e de acordo com as leis vigentes e normas internas, evitando-se mau uso e exposição indevida.</li>
          <li>A informação é utilizada de forma transparente e apenas para a finalidade para a qual foi coletada.</li>
          <li>Todo processo, durante seu ciclo de vida, é tratado com segregação de funções, por meio da participação de mais de um colaborador ou equipe de colaboradores evitando conflitos de interesse e fraudes.</li>
          <li>O acesso às informações e recursos só é feito se devidamente autorizado, incluindo o acesso aos ambientes físicos da StartSe, onde ocorre tratamento de informações.</li>
          <li>A identificação de qualquer colaborador é única, pessoal e intransferível, qualificando-o como responsável pelas ações realizadas.</li>
          <li>A concessão de acessos obedece ao princípio do menor privilégio, no qual os usuários têm acesso somente aos recursos de informação imprescindíveis para o pleno desempenho de suas atividades.</li>
          <li>A senha é utilizada como assinatura eletrônica e é mantida secreta, sendo proibido seu compartilhamento.</li>
          <li>Os riscos às informações da StartSe são reportados à área de Segurança da Informação.</li>
          <li>As responsabilidades quanto à Segurança da Informação são amplamente divulgadas aos colaboradores, que entendem e asseguram estas diretrizes.</li>
          <li>A informação recebe proteção adequada em observância aos princípios e diretrizes de Segurança da Informação da Instituição em todo o seu ciclo de vida, que compreende: Geração, Manuseio, Armazenamento, Transporte e Descarte.</li>
          <li>Os ativos da informação são identificados de forma individual, inventariados e protegidos de acessos indevidos, e tem documentação e planos de manutenção atualizados.</li>
          <li>As informações são classificadas de acordo com a confidencialidade e as proteções necessárias, nos seguintes níveis: Confidencial, Interna e Pública. Para isso, devem ser consideradas as necessidades relacionadas ao negócio, o compartilhamento ou restrição de acesso e os impactos no caso de utilização indevida das informações.</li>
          <li>As concessões, revisões e exclusões de acesso utilizam ferramentas e processos da Instituição. Os acessos são rastreáveis, a fim de garantir que todas as ações passíveis de auditoria possam identificar individualmente o colaborador, para que seja responsabilizado por suas ações.</li>
          <li>Os riscos são identificados por meio de um processo estabelecido para análise de vulnerabilidades, ameaças e impactos sobre os ativos de informação da StartSe, para que sejam recomendadas as proteções adequadas. Os cenários de riscos de segurança da informação são escalonados nos fóruns apropriados, para decisão e tratamento.</li>
          <li>Os incidentes de Segurança da Informação da StartSe são reportados à área de Segurança da Informação.</li>
          <li>A StartSe preserva os requisitos de segurança da informação na aquisição de produtos, contratação de serviços ou pessoas e no relacionamento com colaboradores, fornecedores, terceiros, parceiros, contratados e estagiários.</li>
          <li>A StartSe estabelece Gestão de Riscos de Segurança da Informação, Privacidade dos Dados Pessoais e Continuidade dos Negócios, identificando e corrigindo as vulnerabilidades, as ameaças, os riscos e os impactos que envolvem os ativos de informação, por meio da gestão de riscos de segurança e continuidade dos negócios, procedimentos de teste, análise de logs e avaliações periódicas com ciclos de melhoria contínua.</li>
          <li>A StartSe promove a disseminação dos princípios e diretrizes de Segurança da Informação por meio de programas de conscientização e capacitação, com o objetivo de fortalecer a cultura de Segurança da Informação para seus colaboradores e gestores.</li>
        </ol>
        <br/>

        <p id="4"><strong>Penalidades</strong></p>
        <p>As penalidades são aplicadas para garantir que os usuários atuem sempre em conformidade com as diretrizes estabelecidas nesta norma, portanto não será admitido que qualquer usuário justifique violações ou o não cumprimento da norma por desconhecimento desta.  Os colaboradores e terceiros que, de alguma forma, violarem estas as diretrizes ou não cooperarem com as auditorias internas deverão responder em conformidade com o Código de Ética da StartSe.</p>
        <br/>

        <p id="5"><strong>Vigência</strong></p>
        <p>Esta Política entra em vigor a partir da data de sua homologação e publicação, possuindo sua validade por tempo indeterminado e ainda sendo sujeita a revisões anuais ou conforme mudanças significativas nos processos que tenham relação com o procedimento.</p>
        <br/>

        <p id="6"><strong>Documentos Relacionados</strong></p>

        <p><a href="/politica-de-cookies">Política de Cookies</a></p>
        <p><a href="/politica-de-privacidade">Política de Privacidade</a></p>
        <p><a href="/termo-de-autorizacao-de-uso-de-imagem-e-voz">Termo de Autorização de Uso de Imagem e Voz</a></p>
        <p><a href="/politicas-gerais-de-cancelamento-e-remarcacao-v3">Políticas Gerais de Cancelamento e Remarcação</a></p>
        <p><a href="/termo-de-cobranca-de-encargos-por-atraso">Termo de Cobrança de Encargos por Atraso</a></p>
        <br/>

        <p id="7"><strong>Versão e Revisão</strong></p>
        <p>Versão 1</p>

        <p style={{marginTop: 32}}>São Paulo, 10 de Abril de 2025.</p>
        <p><strong>STARTSE INFORMACOES E SISTEMAS LTDA.</strong></p>
      </Content>

      <BackToTop/>
    </Container>
  )
}
